import { useTheme } from "@emotion/react";
import {
	AccessTimeOutlined,
	CalendarTodayOutlined,
	ContentCopy,
	PersonOutlineOutlined,
	SubtitlesOutlined,
	SupportAgentOutlined,
	VisibilityOutlined,
} from "@mui/icons-material";
import {
	Button,
	Chip,
	CircularProgress,
	IconButton,
	Modal,
	Paper,
	Tooltip,
	Typography,
} from "@mui/material";
import { alpha, Box } from "@mui/system";
import dayjs from "dayjs";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { StatusIconCard } from "../../../utils/chipsErp/chipStatusCard";
import scrollClicker from "../../../utils/scrollClicker";
import InternoModalConfirmacaoSaida from "../../modalSaindoDaPagina";
import TicketModalContent from "../detailsTicketComponent";
import useStyles from "./styles";
import TicketModalContentVero from "../detailsTicketVeroComponent";
import { getErpPrincipal } from "../../../services/erpSistema";

export default function TicketComponentVero(params) {
	const {
		protocolo = "",
		descricao = "",
		cliente = "",
		dataCadastro = "",
		usuarioAbertura = "",
		status = 1,
		ticketId = "",
		fluxoAtendimento = "",
		getTicketDetails = () => {},
		isEdit = false,
		setSnackbar = () => {},
		selectedCliente = "",
		isCliente = false,
		servicoId = "",
		labelErp = "",
		variantPaper = "elevation",
		allEtapasFluxoAtendimentos = [],
		refreshAtendimentos = () => {},
		percentSla = null,
		historicoFluxoAtendimento = [],
		hiddenTimeLine = false,
		allInfoTicket = {},
		assunto = "",
		ticketDetails = {},
		// ERP escolhido na tela (tipo e id); sem eles, a variável do front.
		erp: erpProp,
		erpId,
	} = params;
	const erp =
		erpProp || getErpPrincipal();
	const theme = useTheme();
	const styles = useStyles(theme);
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(true);

	const [isEditTicket, setIsEditTicket] = useState(false);
	const [isFinishTicket, setIsFinishTicket] = useState(false);
	const [isEditOs, setIsEditOs] = useState(false);
	const [isNewOs, setIsNewOs] = useState(false);
	const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
	const [editedTicket, setEditedTicket] = useState(false); //Necessário para verificar se houve edição no ticket
	const [value, setValue] = useState(0);
	const colors = Object.keys(theme.palette.colors)?.filter(
		(color) => color !== "white" && color !== "black",
	);

	function adicionarCores(objetos) {
		return objetos?.reduce((acc, item, index) => {
			acc[item] = colors[index % colors?.length];
			return acc;
		}, {});
	}

	const [itensPublic, setItensPublic] = useState({
		mensagens: [],
		anexos: [],
		rfo: [],
	});

	const statusChamado = {
		SOLUCIONADO: 2,

		PENDENTE: 3,

		CANCELADO: 4,

		"EM ATENDIMENTO": 23,
	};

	const labelTabsErp = {
		descricao: "Descrição",
		mensagens: "Mensagens",
	};

	function htmlForText(html) {
		if (!html) return "";

		const tempDiv = document.createElement("div");
		tempDiv.innerHTML = html;

		function extrairTexto(node) {
			let texto = "";

			node.childNodes.forEach((child) => {
				if (child.nodeType === Node.TEXT_NODE) {
					texto += child.textContent;
				} else if (child.nodeType === Node.ELEMENT_NODE) {
					const tag = child.tagName;

					switch (tag) {
						case "BR":
							texto += "\n";
							break;
						case "P":
						case "DIV":
							texto += extrairTexto(child) + "\n";
							break;
						case "LI":
							texto += "- " + extrairTexto(child) + "\n";
							break;
						case "UL":
						case "OL":
							texto += extrairTexto(child) + "\n";
							break;
						default:
							texto += extrairTexto(child);
					}
				}
			});

			return texto;
		}

		// Extrai texto e normaliza múltiplas quebras de linha
		const resultado = extrairTexto(tempDiv);
		return resultado.replace(/\n{3,}/g, "\n\n").trim();
	}
	const handleChange = (event, newValue) => {
		setValue(newValue);
		setIsEditOs(false);
		setIsEditTicket(false);
		setIsFinishTicket(false);
	};

	const handleOpen = async (item) => {
		setOpen(true);
		setLoading(true);

		setLoading(false);
	};
	const handleClose = () => {
		setOpen(false);
		setIsEditTicket(false);
		setIsFinishTicket(false);
		setIsEditOs(false);
		setIsNewOs(false);
		setConfirmacaoSaidaPagina(false);
		setValue(0);
		if (editedTicket) {
			refreshAtendimentos();
			setEditedTicket(false);
		}
	};

	const fluxoAtendimentoColor = adicionarCores(allEtapasFluxoAtendimentos);

	const handleCancelNavigation = () => {
		setConfirmacaoSaidaPagina(false);
	};

	return (
		<Paper
			elevation={theme.palette.mode == "dark" ? 0 : 3}
			variant={variantPaper}
			sx={styles.paperContainer}
		>
			{StatusIconCard([statusChamado[status]])}

			<Box sx={styles.containerHeader}>
				<Box sx={styles.boxProtocolo}>
					<Typography
						sx={{
							fontSize: "12px",
							fontWeight: "bold",

							color:
								theme.palette.mode === "dark"
									? theme.palette.colors.black.light
									: theme.palette.colors.black.medium,
						}}
					>
						{" "}
						Protocolo:
					</Typography>
					<Typography
						sx={{
							...styles.titleProtocolo,
							color:
								theme.palette.mode === "dark"
									? theme.palette.primary.main
									: theme.palette.tertiary.main,
						}}
					>
						{protocolo}
					</Typography>

					<Tooltip title="Clique para copiar">
						<IconButton
							size="small"
							onClick={async () => {
								try {
									await navigator.clipboard.writeText(protocolo);
								} catch (err) {
									// Fallback para navegadores mais antigos ou sem permissão
									const textArea = document.createElement("textarea");
									textArea.value = protocolo;
									document.body.appendChild(textArea);
									textArea.select();
									try {
										document.execCommand("copy");
									} catch (err) {
										console.error("Falha ao copiar texto: ", err);
									}
									document.body.removeChild(textArea);
								}
								setSnackbar({
									children: "Campo copiado!",
									severity: "info",
								});
							}}
						>
							<ContentCopy sx={{ fontSize: "15px" }} />
						</IconButton>
					</Tooltip>
				</Box>
				<Box sx={styles.boxProtocolo}>
					<Typography
						sx={{
							fontSize: "12px",
							fontWeight: "bold",
							color:
								theme.palette.mode === "dark"
									? theme.palette.colors.black.light
									: theme.palette.colors.black.medium,
						}}
					>
						{" "}
						{labelErp} ID:
					</Typography>
					<Typography
						sx={{
							...styles.titleProtocolo,
							color:
								theme.palette.mode === "dark"
									? theme.palette.primary.main
									: theme.palette.tertiary.main,
						}}
					>
						{servicoId}
					</Typography>

					<Tooltip title="Clique para copiar">
						<IconButton
							size="small"
							onClick={async () => {
								try {
									await navigator.clipboard.writeText(servicoId);
								} catch (err) {
									// Fallback para navegadores mais antigos ou sem permissão
									const textArea = document.createElement("textarea");
									textArea.value = servicoId;
									document.body.appendChild(textArea);
									textArea.select();
									try {
										document.execCommand("copy");
									} catch (err) {
										console.error("Falha ao copiar texto: ", err);
									}
									document.body.removeChild(textArea);
								}
								setSnackbar({
									children: "Campo copiado!",
									severity: "info",
								});
							}}
						>
							<ContentCopy sx={{ fontSize: "15px" }} />
						</IconButton>
					</Tooltip>
				</Box>
			</Box>

			<Box sx={styles.containerDescription}>
				<Typography sx={styles.description}>{descricao}</Typography>
			</Box>
			<Box sx={styles.boxInfos}>
				<Tooltip title={cliente}>
					<Box
						sx={{
							...styles.containerInfo,
							cursor: "pointer",
							"&:hover": {
								textDecoration: "underline",
							},
						}}
						onClick={() => {
							if (selectedCliente?.id) {
								const clienteFilterData = JSON.parse(
									localStorage.getItem("filterData"),
								);

								let clientStorage = clienteFilterData;
								if (clienteFilterData?.clienteId !== selectedCliente?.id) {
									clientStorage = {
										interfaceId: "",
										clienteId: selectedCliente?.id,
										hostId: "",
										selectTime: 5,
										initialDate: "",
										finalDate: "",
									};
								}
								localStorage.setItem(
									"filterData",
									JSON.stringify(clientStorage),
								);
								navigate(
									`/interno/home/perfil/servicos/${selectedCliente?.id}`,
								);
							} else {
								setSnackbar({
									children: "Cliente não cadastrado no sistema",
									severity: "warning",
								});
							}
						}}
						onMouseDown={(e) => {
							if (selectedCliente?.id) {
								const clienteFilterData = JSON.parse(
									localStorage.getItem("filterData"),
								);

								let clientStorage = clienteFilterData;
								if (clienteFilterData?.clienteId !== selectedCliente?.id) {
									clientStorage = {
										interfaceId: "",
										clienteId: selectedCliente?.id,
										hostId: "",
										selectTime: 5,
										initialDate: "",
										finalDate: "",
									};
								}
								localStorage.setItem(
									"filterData",
									JSON.stringify(clientStorage),
								);
								scrollClicker(
									e,
									false,
									`/interno/home/perfil/servicos/${selectedCliente?.id}`,
								);
							} else {
								setSnackbar({
									children: "Cliente não cadastrado no sistema",
									severity: "warning",
								});
							}
						}}
					>
						<PersonOutlineOutlined
							sx={{
								...styles.icon,
								color:
									theme.palette.mode == "dark"
										? theme.palette.colors.black.light
										: theme.palette.colors.black.medium,
							}}
						/>{" "}
						<Typography sx={styles.cardDescricao}>{cliente}</Typography>
					</Box>
				</Tooltip>
				<Box sx={styles.containerInfo}>
					<Box sx={styles.containerInfo}>
						<SubtitlesOutlined
							sx={{
								...styles.icon,
								color:
									theme.palette.mode == "dark"
										? theme.palette.colors.black.light
										: theme.palette.colors.black.medium,
								fontSize: "18px",
							}}
						/>{" "}
						<Tooltip title={assunto}>
							<Typography sx={styles.cardDescricao}>{assunto}</Typography>
						</Tooltip>
					</Box>
				</Box>
				<Box sx={styles.containerInfo}>
					<Box sx={styles.containerInfo}>
						<CalendarTodayOutlined
							sx={{
								...styles.icon,
								color:
									theme.palette.mode == "dark"
										? theme.palette.colors.black.light
										: theme.palette.colors.black.medium,
								fontSize: "18px",
							}}
						/>{" "}
						<Typography sx={styles.cardDescricao}>{dataCadastro}</Typography>
					</Box>
				</Box>

				<Box
					sx={{
						...styles.containerInfo,
						display: "flex",
						alignItems: "center",
						minWidth: 0,
					}}
				>
					<SupportAgentOutlined
						sx={{
							...styles.icon,
							flexShrink: 0, // Garante que o ícone não mude de tamanho
							color:
								theme.palette.mode === "dark"
									? theme.palette.primary.main
									: theme.palette.tertiary.main,
						}}
					/>

					<Tooltip
						title={
							allInfoTicket?.usuario_responsavel?.length > 0 ? (
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										gap: 0.5,
										padding: "4px",
									}}
								>
									{allInfoTicket.usuario_responsavel.map((u, index) => (
										<Typography
											key={u.id || index}
											variant="caption"
											sx={{
												display: "block",
												whiteSpace: "normal", // Permite a quebra de linha natural
												wordBreak: "break-word",
											}}
										>
											• {u.name}
										</Typography>
									))}
								</Box>
							) : (
								""
							)
						}
						arrow
					>
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								gap: 1,
								minWidth: 0,
								flex: 1,
							}}
						>
							<Typography
								noWrap
								sx={{
									...styles.cardDescricao,
									fontWeight: "bold",
									minWidth: 0, // Reforça o truncamento
									color:
										theme.palette.mode === "dark"
											? theme.palette.primary.main
											: theme.palette.tertiary.main,
								}}
							>
								{allInfoTicket?.usuario_responsavel?.[0]?.name ||
									"Sem responsável"}
							</Typography>

							{allInfoTicket?.usuario_responsavel?.length > 1 && (
								<Chip
									label={`+${allInfoTicket.usuario_responsavel.length - 1}`}
									size="small"
									sx={{
										fontWeight: "bold",
										flexShrink: 0,
										height: 20,
										fontSize: "0.75rem",
										backgroundColor: "primary.main",
										color: "primary.contrastText",
									}}
								/>
							)}
						</Box>
					</Tooltip>
				</Box>

				<Box sx={styles.containerButton}>
					<Button
						onClick={() => handleOpen()}
						sx={styles.buttonDetails}
						startIcon={<VisibilityOutlined />}
						variant="outlined"
						size="small"
					>
						Ver detalhes
					</Button>
				</Box>
			</Box>
			<Modal
				open={open}
				onClose={() =>
					isEditTicket || isFinishTicket || isEditOs || isNewOs
						? setConfirmacaoSaidaPagina(true)
						: handleClose()
				}
				/*  onClose={handleClose} */
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				{loading ? (
					<Box sx={styles.containerModal}>
						<Box sx={styles.conatinerLoading}>
							<CircularProgress />
						</Box>
					</Box>
				) : (
					<>
						<TicketModalContentVero
							handleClose={() =>
								isEditTicket || isFinishTicket || isEditOs || isNewOs
									? setConfirmacaoSaidaPagina(true)
									: handleClose()
							}
							erp={erp}
							erpId={erpId}
							ticketDetails={ticketDetails}
							status={statusChamado[status]}
							labelTabsErp={labelTabsErp}
							value={value}
							handleChange={handleChange}
							isEdit={isEdit}
							itensPublic={itensPublic}
							setItensPublic={setItensPublic}
							isCliente={isCliente}
							htmlForText={htmlForText}
							setSnackbar={setSnackbar}
							fluxoAtendimentoColor={fluxoAtendimentoColor}
							setEditedTicket={setEditedTicket}
							historicoFluxoAtendimento={historicoFluxoAtendimento}
							setIsEditTicket={setIsEditTicket}
							isEditTicket={isEditTicket}
							setIsFinishTicket={setIsFinishTicket}
							isFinishTicket={isFinishTicket}
							isEditOs={isEditOs}
							setIsEditOs={setIsEditOs}
							setIsNewOs={setIsNewOs}
							isNewOs={isNewOs}
						/>
						<InternoModalConfirmacaoSaida
							openConfirmacao={confirmacaoSaidaPagina}
							confirmLoad={false}
							setOpenConfirmacao={setConfirmacaoSaidaPagina}
							execute={handleClose}
							cancel={handleCancelNavigation}
							severity={"warning"}
							title={"Atenção"}
							contentText={
								"As alterações não salvas serão perdidas, deseja continuar?"
							}
							headerText={"Você está prestes a sair do modo de edição."}
							confirmText={"Continuar"}
						/>
					</>
				)}
			</Modal>
		</Paper>
	);
}
